import React from "react";
import { Row } from "react-bootstrap";
import Content from "../Content/Content";
import { HomePageView } from "../../types";
import calculateHeightFromContent from "../utils/calculateHeightFromContent";
import { StyledPreview } from "./styled";
var getWidth = function (columnWidth) {
    switch (columnWidth) {
        case 3:
            return 292;
        case 4:
            return 390;
        case 6:
        default:
            return 585;
    }
};
var Preview = function (_a) {
    var companyNewsTileConfig = _a.companyNewsTileConfig;
    var cols = 12 / companyNewsTileConfig.columnWidth;
    var arr = [];
    for (var index = 0; index < cols; index++) {
        arr.push(index);
    }
    // @ts-ignore
    var height = calculateHeightFromContent(arr);
    return (React.createElement(Row, null,
        React.createElement(StyledPreview, { height: height + 30, width: getWidth(companyNewsTileConfig.columnWidth) },
            React.createElement(Content, { companyNewsTile: {
                    config: Object.assign({}, companyNewsTileConfig, { columnWidth: 12 }),
                    xpos: 0,
                    ypos: 0
                }, pageView: HomePageView.EMPLOYEE_VIEW }))));
};
export default Preview;
